import React from 'react'
import { Link, IndexLink } from 'react-router'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'

const MenuNode = (props) => {

	const { linkIndex, linkTo, linkTitle, itemIcon, open } = props;

	if (linkIndex) {
		return (
			<li>
				<IndexLink to="/" className="menu-item" activeClassName="active">
					{(!open && !navigator.userAgent.match(/(iPad)/))
						? <OverlayTrigger
							placement="right"
							delayHide={100}
							overlay={
								<Tooltip id="sidemenu-tooltip" className="tooltip custom-tooltips">
									{linkTitle}
								</Tooltip>
							}
						>
							{itemIcon}
						</OverlayTrigger>
						: itemIcon
					}
					<div className="text">{linkTitle}</div>
				</IndexLink>
			</li>
		)
	}

	return (
		<li>
			<Link to={linkTo} className="menu-item" activeClassName="active">
				{(!open && !navigator.userAgent.match(/(iPad)/))
					? <OverlayTrigger
						placement="right"
						delayHide={100}
						overlay={
							<Tooltip id="sidemenu-tooltip" className="tooltip custom-tooltips">
								{linkTitle}
							</Tooltip>
						}
					>
						{itemIcon}
					</OverlayTrigger>
					: itemIcon
				}
				<div className="text">{linkTitle}</div>
			</Link>
		</li>
	)
}

export default MenuNode;
